<template>
	<div class="missed-payment">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<h3 class="mb-0">Missed payment history</h3>
			</b-card-header>
			<div v-if="tableData.length > 0" class="card-table rounded-bottom">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column label="Date/Facility Type" min-width="210" show-summary width="auto">
						<template slot-scope="scope">
							<p class="mb-0 top-line">{{ scope.row.missed_pay_approved_date }}</p>
							<p class="text-uppercase mb-0">{{ scope.row.missed_pay_loan_statue }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="missed_pay_credit_limit" label="Limit (RM)" min-width="150" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.missed_pay_credit_limit | moneyFormatter }}</p>
							<!-- <p class="top-line">{{ scope.row.missed_pay_credit_limit }}</p> -->
						</template>
					</el-table-column>
					<el-table-column prop="missed_pay_payment_history" label="Payment History" min-width="200" width="auto">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.missed_pay_payment_history }}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No Misses Payment History recorded</p>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Card, Button, Table, TableColumn } from 'element-ui'

export default {
	name: 'missed-payment',
	props: ['missed_payment_history'],
	components: {
		[Card.name]: Card,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			tableData: this.missed_payment_history
		}
	}
}
</script>